<template>
  <div id="layout">
    <Header></Header>
    <el-container class="mainframe">
      <el-container>
        <el-aside>
          <SidebarNew></SidebarNew>
        </el-aside>
        <el-container>
          <el-main>
            <router-view />
          </el-main>
          <el-footer>
            <Footer></Footer>
          </el-footer>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>
<script>
export default {
  name: 'Layout',
  data () {
    return {
    };
  }
};
</script>

<style lang="scss">
#app {
  // font-family: 'Metal Mania', cursive;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #5b5b5b;
  text-align: center;
  .el-aside {
    width: 0px !important;
  }
  .mainframe {
    padding-left: 260px;
    padding-top: 50px;
    min-height: 100vh;
  }
}
@media (max-width: 1218px) {
  #app {
    .mainframe {
      padding-left: 0px;
    }
  }
}
</style>

<script>
import SidebarNew from '@/components/SidebarNew'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
  components: {
    Header,
    SidebarNew,
    Footer
  },
  data () {
    // const item = {
    //   date: '2016-05-02',
    //   name: 'Tom',
    //   address: 'No. 189, Grove St, Los Angeles'
    // }
    return {
      // tableData: Array(20).fill(item)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Layout.vue